if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const personalized =
  formData.get('properties[Kişiselleştirme]') === 'Evet';

if (personalized) {
  const quantity = Number(formData.get('quantity') || 1);
  const productInfo = this.closest('product-info');
  const pieceFields = Array.from(
    productInfo?.querySelectorAll('[data-personalization-piece]') || []
  );

  const pieces = pieceFields.length
    ? pieceFields.map((field) => ({
        design: String(
          field.querySelector('[data-piece-design]')?.value || ''
        ).trim(),
        inscription: String(
          field.querySelector('[data-piece-text]')?.value || ''
        ).trim()
      }))
    : [{
        design: String(
          formData.get('properties[Dizayn numarası]') || ''
        ).trim(),
        inscription: String(
          formData.get('properties[Yazılacak yazı]') || ''
        ).trim()
      }];

  let validationError = '';

  if (
    !Number.isInteger(quantity) ||
    quantity < 1 ||
    pieces.length !== quantity
  ) {
    validationError =
      'Seçilen her adet için ayrı kişiselleştirme alanı doldurulmalıdır.';
  } else {
    const incomplete = pieces.findIndex((piece) =>
      !/^Dizayn [1-7]$/.test(piece.design) || !piece.inscription
    );

    if (incomplete !== -1) {
      validationError =
        `Ürün ${incomplete + 1} için dizayn seçin ve yazıyı girin.`;
    }
  }

  if (validationError) {
    this.handleErrorMessage(validationError);
    this.submitButton.removeAttribute('aria-disabled');
    this.submitButton.classList.remove('loading');
    this.querySelector('.loading__spinner').classList.add('hidden');
    return;
  }

  const productId = formData.get('id');
  const originalFields = Array.from(formData.entries());

  originalFields.forEach(([name]) => formData.delete(name));

  pieces.forEach((piece, index) => {
    const pairId = crypto.randomUUID();
    const productIndex = index * 2;
    const serviceIndex = productIndex + 1;

    const addField = (itemIndex, name, value) => {
      formData.append(`items[${itemIndex}][${name}]`, value);
    };

    const addProperty = (itemIndex, name, value) => {
      formData.append(
        `items[${itemIndex}][properties][${name}]`,
        value
      );
    };

    addField(productIndex, 'id', productId);
    addField(productIndex, 'quantity', '1');

    originalFields.forEach(([name, value]) => {
      const property = name.match(/^properties\[(.+)\]$/);

      if (property && ![
        'Dizayn numarası',
        'Yazılacak yazı',
        '_personalization_pair',
        '_personalization_service'
      ].includes(property[1])) {
        addProperty(productIndex, property[1], value);
      }

      if (name === 'selling_plan' && value) {
        addField(productIndex, 'selling_plan', value);
      }
    });

    addProperty(productIndex, 'Dizayn numarası', piece.design);
    addProperty(productIndex, 'Yazılacak yazı', piece.inscription);
    addProperty(productIndex, '_personalization_pair', pairId);

    addField(serviceIndex, 'id', '68002213757016');
    addField(serviceIndex, 'quantity', '1');
    addProperty(serviceIndex, '_personalization_pair', pairId);
    addProperty(serviceIndex, '_personalization_service', 'true');
    addProperty(serviceIndex, 'Dizayn numarası', piece.design);
    addProperty(serviceIndex, 'Yazılacak yazı', piece.inscription);
  });
}
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (personalized || !this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
